import React, { Component } from 'react'
import Users from '../../constants/users'
import { LargeButton, Input, Ptag, InputBox } from '../../components/core'
import { Formik, Form } from "formik";
import * as Yup from "yup";
import config from '../../config.json'
import showPassword from '../../assets/images/view.png'
import hidePassword from '../../assets/images/hide.png'
import maskGroup from '../../assets/images/mask_group.png'
import http  from '../../services/httpService'
import { Navigate } from "react-router-dom";

import {
    Text, 
    PasswordIndicator, 
    InputContainer, 
    Alert, 
    Border2, 
    Divisiontag,
    DivisiontagImg, 
    ManagerImage, 
    Border, 
    Page 
} from './style'




class forgetPassword extends React.Component {

        constructor(props){
            super(props)
            this.state = {
                viewPassword : false,
                redirect : false
            }
        }

        componentDidMount(){           

        }

        toggleViewPassword = () => {
            this.setState({viewPassword : !this.state.viewPassword})
        }

        renderInput = ({
            name,
            placeholder,
            type,
            formikProps,
            length = 70,
          } = {}) => {
            const { errors, touched, handleBlur, values, handleChange } = formikProps;
            const error = touched[name] && errors[name];
            const {viewPassword} = this.state
            const mutatedType = type === 'password' ? (viewPassword ? "text" : type ) : type === 'reenterpassword'? 'password' : type
            return (
              <InputContainer>
                <InputBox
                  value={values[name]}
                  style={{'padding': '0rem 2rem'}}
                  name={name}
                  placeholder={placeholder}
                  type={mutatedType}
                  error={error}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
                {/* {
                    type === 'password' && 
                    <PasswordIndicator src={viewPassword ? showPassword : hidePassword} onClick={this.toggleViewPassword} />
                } */}
              </InputContainer>
            );
        };

        handleSubmit = async (values, formik) => {
            formik.setErrors({})
            if(values['password'] !== values['reenterpassword']){
                formik.setFieldError('reenterpassword', 'Passwords do not match')
                return
            }  
            try{
                    const {data} = await  http.post("/users/update_password/",{
                        email: values['email'],
                        password: values['password']
                    })
                    localStorage.setItem('email', values['email'])
                    localStorage.setItem('password', values['password'])
                    localStorage.setItem('auth_token',data.token)
                    localStorage.setItem('user_id', data.user_id)
                    this.setState({redirect : true})

            } catch(e){
                    alert(e.response['data'])
            }
        }

        renderForm = (formikProps) => {

            return (
                <>
                    <Form>
                    {this.renderInput({
                        name: "email",
                        placeholder: "Email",
                        type: "text",
                        formikProps,
                    })}
                    {this.renderInput({
                        name: "password",
                        placeholder: "Set Password",
                        type: "password",
                        formikProps,
                    })}
                    {this.renderInput({
                        name: "reenterpassword",
                        placeholder: "Re-Enter Password",
                        type: "reenterpassword",
                        formikProps,
                    })}
                    <LargeButton
                        type="submit"
                        style={{'marginTop': '50px'}}
                        label={"Confirm"}
                        
                    />
                    </Form>
                </>
            )
        }

        render(){
            let initialValues = {
                    password: "",
                    email:"",
                    reenterpassword: ""
                }
            
            let Schema = Yup.object().shape({
                        email: Yup.string().email().required("*Required"),
                        password: Yup.string().required("*Required"),
                        reenterpassword: Yup.string().required("*Required"),
                    });
            return (
                <>
                    {
                        <>{this.state.redirect && <Navigate to="/managerDashBoard" replace={false} />}
                            <Border>
                                <Border2>
                                    <ManagerImage>
                                    <Divisiontag style={{minWidth:"58%"}}>
                                        <Page>
                                            <Alert>
                                            <Formik
                                                initialValues={initialValues}
                                                validationSchema={Schema}
                                                enableReinitialize={true}
                                                onSubmit={this.handleSubmit}
                                                render={this.renderForm}
                                            />
                                            </Alert>
                                        </Page>
                                    </Divisiontag>
                                    <Divisiontag>
                                        <img src={maskGroup} width="100%" /> 
                                    </Divisiontag>
                                    </ManagerImage>
                                </Border2>
                            </Border>
                        </>
                    }
                </>
                
            )
        }
    }

    export default forgetPassword


